import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { IMngNumberFormat } from '../input.types';
import { MatError, MatFormField, MatLabel, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { NumberFieldDirective } from './number-field.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';

@Component({
  selector: 'mng-inputfield-number',
  imports: [
    MatFormField,
    MatLabel,
    MatPrefix,
    NgStyle,
    ExtendedModule,
    MatSuffix,
    MatInput,
    ReactiveFormsModule,
    NumberFieldDirective,
    NumbersOnlyDirective,
    MatError
  ],
  template: `
    <mat-form-field
      style="width: 100%;"
      [ngStyle]="ngStyle()"
      [attr.id]="field().id"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
      [floatLabel]="floatLabel()"
    >
      @if (field().label) {
        <mat-label>{{ field().label }}</mat-label>
      }
      <input
        style="text-align: right; {{ inputTextStyle() }}"
        type="text"
        matInput
        autocomplete="off"
        [id]="field().id"
        [mngNumberField]="options()"
        [mngNumbersOnly]="options()"
        [placeholder]="field().placeHolder"
        [formControl]="field().control"
        (blur)="onBlur()"
        (keyup)="onKeyEvent($event)"
      />
      @if (prefix()) {
        <span matTextPrefix>&nbsp;{{ prefix() }}</span>
      }
      @if (suffix()) {
        <span matTextSuffix>&nbsp;{{ suffix() }}</span>
      }
      @if (hasErrors) {
        <mat-error style="text-align: right;"> {{ validationMessage }} </mat-error>
      }
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldNumberComponent extends InputFieldBaseComponent {
  readonly suffix = input<string | undefined>();
  readonly prefix = input<string | undefined>();

  readonly allowNegativeNumber = input(false, { transform: booleanAttribute });
  readonly allowDecimals = input(false, { transform: booleanAttribute });

  readonly options = computed<IMngNumberFormat>(() => ({
    allowNegativeNumber: this.allowNegativeNumber(),
    allowDecimals: this.allowDecimals()
  }));
}
